function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
if (window.screen.width >= 768 &&  document.getElementById("PopupModal-qrcode")) {
  document.getElementById("PopupModal-qrcode").remove();
}

let allPagesLoaded = false;
let zeroPriceBuffer = [];

function reorderAndBufferZeroPriceProducts(containerSelector = '.productgrid--items', itemSelector = 'li[data-product-item]') {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const items = Array.from(container.querySelectorAll(itemSelector));

  const nonZero = [];
  const zeroPrice = [];

  items.forEach(item => {
    let price = parseFloat((item.dataset.price || '0').replace(/[^0-9.]/g, ''));
    if (isNaN(price)) price = 0;

    if (price === 0) {
      zeroPrice.push(item);
    } else {
      nonZero.push(item);
    }
  });

  // Remove all from container first
  items.forEach(item => item.remove());

  // Keep at least 10 total visible (to keep scroll working)
  const minimumVisible = 10;
  const neededFromZero = Math.max(minimumVisible - nonZero.length, 0);

  const zeroToKeep = zeroPrice.slice(0, neededFromZero);
  const zeroToBuffer = zeroPrice.slice(neededFromZero);

  zeroToBuffer.forEach(item => zeroPriceBuffer.push(item));

  const finalList = nonZero.concat(zeroToKeep);
  finalList.forEach(item => container.appendChild(item));
}

function revealBufferedZeroPriceProducts(containerSelector = '.productgrid--items') {
  const container = document.querySelector(containerSelector);
  if (!container || zeroPriceBuffer.length === 0) return;

  // ✅ Clean up placeholders
  container.querySelectorAll('.product-placeholder').forEach(p => p.remove());

  zeroPriceBuffer.forEach(item => container.appendChild(item));
  zeroPriceBuffer = [];

  if (typeof rimg === 'function') rimg();
}


function revealAllZeroPriceItems() {
  document.querySelectorAll('.product--zero-price.hidden').forEach(item =>
    item.classList.remove('hidden')
  );
  if (typeof rimg === 'function') rimg();
}

function isSearchPage() {
  return document.body.classList.contains('template-search');
}

/*document.addEventListener('DOMContentLoaded', () => {
  if (!isSearchPage()) return;

  reorderAndBufferZeroPriceProducts();
  checkIfAllResultsLoaded(); // ✅ NEW
});*/

function checkIfAllResultsLoaded(containerSelector = '.productgrid--items') {
  const container = document.querySelector(containerSelector);
  if (!container || allPagesLoaded) return;

  const totalFromLiquid =
    window.searchTotalResults ||
    parseInt(document.querySelector('#search-results-total')?.dataset.total || '0', 10);

  const visibleItems = container.querySelectorAll('li[data-product-item]').length;
  const bufferedItems = zeroPriceBuffer.length;
  const totalRendered = visibleItems + bufferedItems;

  console.log('[Product Count Debug]');
  console.log('→ Visible items:', visibleItems);
  console.log('→ Buffered $0 items:', bufferedItems);
  console.log('→ Total rendered:', totalRendered);
  console.log('→ Expected total from Liquid:', totalFromLiquid);

  // ✅ Allow 1–2 item difference (for non-product results like pages/articles)
  if ((totalRendered >= totalFromLiquid - 2) && !allPagesLoaded) {
    allPagesLoaded = true;
    console.log('✅ Close enough to total. Revealing $0 items...');
    revealBufferedZeroPriceProducts();
  }
}

function padGridWithPlaceholders(count, containerSelector = '.productgrid--items') {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  for (let i = 0; i < count; i++) {
    const placeholder = document.createElement('li');
    placeholder.classList.add('productgrid--item', 'product-placeholder');
    placeholder.style.display = 'none'; // Hide from user but keep in DOM
    container.appendChild(placeholder);
  }
}

function revealSomeZeroPriceItems(batchSize = 3) {
  const hiddenItems = document.querySelectorAll('.product--zero-price.hidden');
  for (let i = 0; i < Math.min(batchSize, hiddenItems.length); i++) {
    hiddenItems[i].classList.remove('hidden');
  }
}